import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { GachaID } from './gacha.ruleset';
import { getAvailableGachas, rollGacha } from './gacha.getters';
import { consumeGachaCurrency, consumeGachaRewards } from './gacha.modifiers';

import { AnalyticsEvent, sendAnalyticsEvents } from '../analytics';

export const gachaActions = createActions({
  purchaseGacha: action((state, { gachaId }: { gachaId: GachaID }, api) => {
    const now = api.date.now();

    // Get all available gachas.
    const availableGachas = getAvailableGachas(state, now);

    const isGachaAvailable = availableGachas.some(({ id }) => id === gachaId);

    // Check if gacha is available.
    if (!isGachaAvailable) {
      throw new Error(`Gacha ${gachaId} is not available.`);
    }

    const events: AnalyticsEvent[] = [];

    // Consume currency. And send analytics event.
    consumeGachaCurrency(state, gachaId, api);

    // Grant items.
    const { items, events: rollevents } = rollGacha(
      state,
      gachaId,
      api.math.random,
      now,
    );

    // Push tracking events.
    events.push(...rollevents);

    // Send analytics events.
    sendAnalyticsEvents(api, events);

    consumeGachaRewards(state, items, now);

    return items;
  }),
});
